import { SkyClubCard } from '../models/skyclub.interfaces';
import { Tracking75k, TrackingLessThan75k } from './trackerFooter.mocks';
import { BusinessAmex, ReserveAmex, SkyClubAmex } from './type.mocks';
import {
  MemberSkyClubVisits,
  SingleVisit,
  SingleVisitDifferentCount,
  Unlimited75KVisits,
  UsedAllVisits
} from './visits.mocks';

export const SingleCard: SkyClubCard[] = [
  {
    visit: SingleVisit,
    type: BusinessAmex, // For the card type information
    spendTracker: TrackingLessThan75k // For the Tracker information
  }
];

export const UsedAllVisitsCard: SkyClubCard[] = [
  {
    visit: UsedAllVisits,
    type: BusinessAmex,
    spendTracker: TrackingLessThan75k
  }
];

export const MultipleCards: SkyClubCard[] = [
  {
    visit: SingleVisit,
    type: BusinessAmex,
    spendTracker: TrackingLessThan75k
  },
  {
    visit: SingleVisitDifferentCount,
    type: ReserveAmex,
    spendTracker: TrackingLessThan75k
  },
  {
    visit: Unlimited75KVisits,
    type: BusinessAmex,
    spendTracker: Tracking75k,
    thresholdMet: true
  },
  {
    visit: MemberSkyClubVisits,
    type: SkyClubAmex,
    searchEligibleFooter: {
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/location.svg',
        alt: 'Search Logo'
      },
      label: 'Search eligible Sky Clubs',
      url: ''
    }
  },
  {
    visit: UsedAllVisits,
    type: BusinessAmex,
    spendTracker: TrackingLessThan75k
  }
];

export const UnlimitedAccess75kCard: SkyClubCard[] = [
  {
    visit: Unlimited75KVisits,
    type: BusinessAmex,
    spendTracker: Tracking75k,
    thresholdMet: true
  }
];

export const UnlimitedAccessMemberSkyClubCard: SkyClubCard[] = [
  {
    visit: MemberSkyClubVisits,
    type: SkyClubAmex,
    searchEligibleFooter: {
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/location.svg',
        alt: 'Search Logo'
      },
      label: 'Search eligible Sky Clubs',
      url: ''
    }
  }
];
